import React from "react";

import { Grid } from "@mui/material";
import { Skeleton, Stack } from "@mui/material";

export const ProductDetailsSkeleton = () => {
  const heightInput = 60;

  return (
    <Grid container direction="row" spacing={2}>
      <Grid item xs={6}>
        <Stack spacing={1}>
          <Stack direction="row" spacing={2}>
            <Skeleton variant="text" width="100%" height={heightInput} />
            <Skeleton variant="text" width="100%" height={heightInput} />
          </Stack>
          <Skeleton variant="text" height={heightInput} />
          <Skeleton variant="text" height={heightInput} />
          <Skeleton variant="text" height={heightInput} />
          <Skeleton variant="text" height={heightInput} />
          <Skeleton variant="text" height={heightInput} />
          <Skeleton variant="text" height={heightInput} />
          <Skeleton variant="text" height={heightInput} />
        </Stack>
      </Grid>
      <Grid item xs={6}>
        <Stack spacing={1}>
          <Skeleton variant="text" height={heightInput} />
          <Skeleton variant="text" height={heightInput} />
          <Stack direction="row" spacing={2}>
            <Skeleton variant="text" width="100%" height={heightInput} />
            <Skeleton variant="text" width="100%" height={heightInput} />
            <Skeleton variant="text" width="100%" height={heightInput} />
          </Stack>
          <Stack direction="row" spacing={2}>
            <Skeleton variant="text" width="100%" height={heightInput} />
            <Skeleton variant="text" width="100%" height={heightInput} />
            <Skeleton variant="text" width="100%" height={heightInput} />
          </Stack>
          <Stack direction="row" spacing={2}>
            <Skeleton variant="text" width="100%" height={heightInput} />
            <Skeleton variant="text" width="100%" height={heightInput} />
            <Skeleton
              style={{ visibility: "hidden" }}
              variant="text"
              width="100%"
              height={heightInput}
            />
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
};
